export const ROUTER_LOAD = 'ROUTER_LOAD'
export const ROUTER_LOAD_PATH = 'ROUTER_LOAD_PATH'
export const ROUTER_LOAD_HASHTAG = 'ROUTER_LOAD_HASHTAG'
export const ROUTER_CLEAR = 'ROUTER_CLEAR'

export const routerLoad = () => {
    return {
        type: ROUTER_LOAD,
    }
}

export const routerLoadPath = (path) => {
    return {
        type: ROUTER_LOAD_PATH,
        path,
    }
}

export const routerLoadHashtag = (hashtag) => {
    return {
        type: ROUTER_LOAD_HASHTAG,
        hashtag,
    }
}

export const routerClear = () => {
    return {
        type: ROUTER_CLEAR
    }
}
